export var VALIDATION_ERROR_CLASS = 'form__validation-error-message';
export var DIRTY_CLASS = 'form__input--dirty';
export var VALID_CLASS = 'form__input--valid';
export var VALIDATION_ERROR_PARENT_CLASS = 'parent-error';
export var INPUT_INVALID_CLASS = 'form__input--invalid';
export var DISABLED_SUBMIT_INPUT = 'btn--disabled';
